import { Dropdown } from "react-bootstrap";
import DonorListPayments from "./DonorListPayments";

function PaymentTypeDropdown({ payments, selectedPayments, handlePaymentChange, setSelectedPayment }){
return (
    <>
    <Dropdown className="d-inline-block">
            <Dropdown.Toggle className="p-0" id="paymentFilterDropdown">
                Payment Type
            </Dropdown.Toggle>

            <Dropdown.Menu  renderOnMount={true} 
                popperConfig={{
                    strategy: "fixed"
                }}>
                <form>
                    {payments.map((payment) => (
                        <DonorListPayments
                        label={payment.label}
                            selectedPayments={selectedPayments}
                            key={payment.id}
                            payments={payment.value}
                            id={payment.id}
                            onClick={handlePaymentChange}
                        />
                    ))}
                </form>
                <div>
                    <input
                        type="button" value="Clear All"
                        className="btn btn-link"
                        onClick={() => setSelectedPayment([])}
                    />


                </div>
            </Dropdown.Menu>
        </Dropdown>
    </>
)
}
export default PaymentTypeDropdown;